module.exports = __webpack_public_path__ + "img/infibo-how-to-buy-a-license-ru-1.399b102a.png";